module.exports = __webpack_public_path__ + "static/media/br2.338d2e90.gif";